module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_5010.b3b8ba6b.png";